import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { cn } from 'src/shared/utils/cn'

type SettingsContainerProps = {
  children: React.ReactNode
  className?: string
}

const SettingsContainer = ({ children, className }: SettingsContainerProps) => {
  const { isTabletOrSmaller, isDesktop } = useBreakpoint()

  return (
    <div
      className={cn(
        'min-h-0 flex-1 overflow-y-auto',
        isTabletOrSmaller ? 'px-5' : 'px-[70px]',
        isDesktop && 'px-[80px]',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default SettingsContainer
